var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconeAvaliadores(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 44,
    viewBox: "0 0 33 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1466_14617)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7608 27.9905C8.32401 27.9905 2.28833 31.0083 2.28833 34.7267C2.28833 37.7446 6.24925 40.2909 11.7191 41.1531V45.5047L17.1081 40.1157L11.7191 34.7267V38.4047C7.47524 37.6503 4.98283 35.8449 4.98283 34.7267C4.98283 33.2986 9.07847 30.685 15.7608 30.685C22.4432 30.685 26.5388 33.2986 26.5388 34.7267C26.5388 35.7102 24.5718 37.273 21.1498 38.1353V40.8971C25.9056 39.8598 29.2333 37.4886 29.2333 34.7267C29.2333 31.0083 23.1977 27.9905 15.7608 27.9905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9363 0.430298C8.85228 0.430298 3.1228 6.15977 3.1228 13.2438C3.1228 22.854 15.9363 37.0404 15.9363 37.0404C15.9363 37.0404 28.7498 22.854 28.7498 13.2438C28.7498 6.15977 23.0204 0.430298 15.9363 0.430298ZM15.9364 17.8202C13.4103 17.8202 11.3602 15.77 11.3602 13.2439C11.3602 10.7178 13.4103 8.66768 15.9364 8.66768C18.4625 8.66768 20.5127 10.7178 20.5127 13.2439C20.5127 15.77 18.4625 17.8202 15.9364 17.8202Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1466_14617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 43.0769,
    fill: "white",
    transform: "translate(0.124023 0.461548)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeAvaliadores);
export default __webpack_public_path__ + "static/media/IconeAvaliadores.eacf82be14fffcae05d98ef160bee3b5.svg";
export { ForwardRef as ReactComponent };